import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.color.white};
  padding: ${rem(17)} ${rem(14)};
  svg {
    position: absolute;
    left: ${rem(14)};
  }
`;
